import React from 'react'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrowLeft.svg'
import s from './Row.module.scss'

export const Row = ({ icon: Icon, title, subtitle, meta, onClick, tone = 'purple' }) => {
	const iconToneClass = tone === 'purple' ? '' : s[`row__icon--${tone}`]

	return (
		<button type="button" className={s.row} onClick={onClick}>
			<span className={`${s.row__icon} ${iconToneClass}`.trim()}>
				<Icon aria-hidden />
			</span>
			<span className={s.row__copy}>
				<strong className={s.row__title}>{title}</strong>
				<span className={s.row__subtitle}>{subtitle}</span>
			</span>
			{meta ? <span className={s.row__meta}>{meta}</span> : null}
			<ArrowIcon className={s.row__arrow} aria-hidden />
		</button>
	)
}

export default Row
